import useDiscoveryFetch from '../useDiscoveryFetch';
import { useState } from 'react';
import api from '../../../api/axiosInstance';

// Company Info / Hiring Info tabs don't get openJobsTotal from their own
// endpoints (/api/discovery/companies/:id and .../hiring don't project it),
// so a small extra read against the existing jobs endpoint is the only way
// to show an accurate count on those tabs' badge. Shared by all three
// Discovery company-detail pages so the fetch isn't tripled.
export const useDiscoveryJobsCount = (companyId) => {
    const [jobsCount, setJobsCount] = useState(null);
    const [loading, setLoading] = useState(true);

    useDiscoveryFetch(({ signal, isCurrent, isReconnect }) => {
        if (!companyId) {
            setJobsCount(null);
            setLoading(false);
            return;
        }

        if (!isReconnect || jobsCount === null) setLoading(true);

        api.get(`/api/discovery/companies/${companyId}/jobs`, { signal })
            .then((res) => {
                if (!isCurrent()) return;

                setJobsCount(Number(res.data?.openJobsTotal) || 0);
            })
            .catch(() => {
                if (!isCurrent()) return;

                setJobsCount(null);
            })
            .finally(() => {
                if (!isCurrent()) return;
                setLoading(false);
            });

    }, [companyId]);

    return { jobsCount, loading };
};

export default useDiscoveryJobsCount;
